import { render, staticRenderFns } from "./approval-disable-vehicle.vue?vue&type=template&id=68d171e3&scoped=true&"
import script from "./approval-disable-vehicle.vue?vue&type=script&lang=js&"
export * from "./approval-disable-vehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d171e3",
  null
  
)

export default component.exports